import { Tag } from '@chakra-ui/react';

export type CoverageLevel = 'Modeled' | 'LeanOnly' | 'Insufficient' | 'TopOfTicket'

const COVERAGE_META: Record<CoverageLevel, { icon: string; label: string; colorScheme: string }> = {
  Modeled: { icon: '✓', label: 'Modeled', colorScheme: 'green' },
  LeanOnly: { icon: '◐', label: 'Lean-only', colorScheme: 'yellow' },
  Insufficient: { icon: '✕', label: 'Insufficient', colorScheme: 'red' },
  TopOfTicket: { icon: '◐', label: 'Top-of-ticket estimate', colorScheme: 'orange' },
}

/**
 * Coverage honesty pill — always icon + label so it reads the same in print and
 * on screen. Shared by the District Profile snapshot card and the scenario
 * seat-board (Task 16).
 */
export function CoverageBadge({ coverage }: { coverage: CoverageLevel }) {
  const meta = COVERAGE_META[coverage]
  return (
    <Tag.Root size="sm" colorPalette={meta.colorScheme} borderRadius="md" flexShrink={0}>
      <Tag.Label>
        {meta.icon} {meta.label}
      </Tag.Label>
    </Tag.Root>
  );
}
